import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { FaqItemProps as Props } from './types';

export const FaqItem = memo(({ className, item }: Props) => {
  return (
    <Accordion
      className={classnames('FaqItem', className)}
      disableGutters
      square={false}
      sx={SX.root}
      variant="outlined"
    >
      <AccordionSummary
        expandIcon={<Icon name="keyboard-arrow-down" size={16} />}
        sx={SX.summary}
      >
        <Typography variant="body3" fontWeight={600} color="grey.700">
          {item.title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={SX.details}>
        <Typography variant="body4" component="div" color="grey.700">
          {item.answer}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
});

FaqItem.displayName = 'FaqItem';
